import tw from 'twin.macro';

export const Wrapper = tw.div`w-1/2 flex items-center justify-center gap-3`;

export const TotalImage = tw.img`w-[3.125rem] h-[3.125rem]`;

export const TotalContent = tw.div`flex flex-col items-start justify-center gap-1`;

export const TotalTitle = tw.h2`text-[1.125rem] font-bold text-black`;
